export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtPPOdhadPodil';
export const NAME = 'OdhadyPracnostiPodil';
